import React from "react";
import { composeDataMethods } from "@lululemon/mwa-utils/esm";
import { useFederatedTargetPageParameters } from "@lululemon/mwa-ab-testing/esm";

export default function withFederatedTargetPageParameters() {
  // eslint-disable-next-line
  return Component => {
    function WithTargetPageParams(props) {
      useFederatedTargetPageParameters({
        remote: "abtFederationHost",
        module: "federatedParams",
      });
      useFederatedTargetPageParameters({
        remote: "pepsFederatedModuleHost",
        module: "federatedParams",
      });

      // eslint-disable-next-line
      return <Component {...props} />;
    }
    return composeDataMethods(Component)(WithTargetPageParams);
  };
}
